export default __webpack_public_path__ + "b5592aabe88cba35e17d54e0126371b4.svg";